















































































import Element from 'element-ui'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { postGrade } from '@/api/heritageCruise/cruiseEvent'
// import singleFile from '@/components/upload/singleFile.vue'
import { showVaildMsg, validateIntKey } from '@/configs/validate'

import { DDLItem, getLookupByType } from '@/api/common/select'
import { enFirstType, enLookupType } from '@/configs/enums'

@Component({
  components: {
    // singleFile
  }
})
export default class EventGradeForm extends Vue {
  public name = 'EventGradeForm'
  public loading: boolean = false
  @Prop({ default: null })
  public callBack!: (data: any) => void

  public form: {
    EventId: number,
    LevelId: number,
    Comments: string,
    AttachType: number,
    AttachGuid: string,
    AttachPath: string
  } =
    {
      EventId: 0,
      LevelId: 0,
      Comments: '',
      AttachType: 0,
      AttachGuid: '',
      AttachPath: ''
    }
  public actionList: any = []
  public levelList: DDLItem[] = []

  public rules: any = {
    LevelId: [{ required: true, validator: validateIntKey('请选择事件级别'), trigger: 'change' }],
    // Comments: [{ required: true, message: '请输入评级理由', trigger: 'blur' }],
    // AttachPath: [{ required: ly.attachRequired, message: '请上传附件' }]
  }

  public $refs!: {
    formData: Element.Form
  }
  public created() { }

  public mounted() {
    //接收数据，父页面使用 window.eventBus.$emit() 发送数据

  }
  public loadData(info: { id: number, actions: any[] }) {
    this.actionList = info.actions
    this.form = {
      EventId: info.id,
      LevelId: 0,
      Comments: '',
      AttachType: 0,
      AttachGuid: '',
      AttachPath: ''
    }
    this.fetchSource()
    // this.fetchData(info)
  }
  public beforeDestroy() {
  }
  public onFileChange(data: { opts: any; file: any }) {
    this.form.AttachPath = data.file.SavePath
    this.$refs.formData.validateField('AttachPath', () => { })
  }
  public fetchSource() {
    this.loading = true
    getLookupByType(enLookupType.EventIssueLevel, enFirstType.Select).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.levelList = data
        this.loading = false
      }
    })
  }
  public fetchData(info: any) {
    // this.loading = true
    // getGradeModel(info.id).then((response: { data: any }) => {
    //   var data = response.data
    //   if (data) {
    //     this.form = data.entity
    //     this.actionList = data.actionList

    //     // this.$refs.formData.clearValidate()
    //     this.$refs.formData.resetFields()
    //   }
    //   this.loading = false
    // })
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        var f = this.form
        postGrade(f).then((response: { data: any }) => {
          let f = Object.assign({}, this.form)
          const data = response.data
          if (data && !data.IsError) {
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            if (this.callBack) {
              this.callBack(this.form)
            }
          } else {
            this.$message({
              dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
            })
            console.log('提交失败', data)
          }
        },
          (data: any) => {
            console.log(data)
          }
        )
      }
      else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
  public onCancel() {
    if (this.callBack) {
      this.callBack(null)
    }
  }
}
